<template>
  <div class="message-new mb-4">

    <div v-show="!add_receivers" class="message-new-form">
      <div class="row message-new-header mt-4">
        <div class="col-4">
          <h1 v-if="messageType.poll" class="message-new-title">Neue Abstimmung</h1>
          <h1 v-else-if="messageType.sick_note" class="message-new-title">Neue Krankmeldung</h1>
          <h1 v-else class="message-new-title">Neue Nachricht</h1>
        </div>
        <div class="col-8">
          <div class="message-new-actions">

            <div v-if="!messageType.poll && !file && !messageType.sick_note" class="message-upload-wrapper">
              <label class="upload">
                <input id="fileId" @change="attachmentUpload" type="file" accept=".png,.jpg,.pdf,.doc,.docx,.xls,.xlsx"/>
                <span><img class="ml-4" :src="'./static/img/' + user.role +'/attachment.png'" alt=""></span>
              </label>
            </div>
            <img @click="$router.go(-1)" class="ml-4 btn-cursor" :src="'./static/img/' + user.role +'/close.png'" alt="">

          </div>
        </div>
      </div>

      <div class="row message-new-form mt-4">
        <div class="col-12">
          <div @click="add_receivers = !add_receivers" class="receivers-list btn-cursor mb-3 pr-5">
            <span v-if="message.selected_receivers.length === 0" class="single-receiver single-receiver-placeholder">
              An
            </span>
            <span v-else-if="!user.parent && message.selected_receivers.length === contacts.length" class="single-receiver">
              Alle Schüler
            </span>
            <span v-else v-for="receiver in message.selected_receivers" class="single-receiver">
              {{ receiver.title }}
            </span>
            <button class="btn-add-receiver">
              <img :src="'./static/img/' + user.role +'/add_contact.png'" height="30">
            </button>
          </div>
          <input v-model="message.title" class="mb-3 form-control" placeholder="Betreff" :readonly="messageType.sick_note" maxlength="150"/>
          <p class="text-right light-grey">{{ message.title | charsLeft(150) }}</p>
          <div v-if="this.messageType.sick_note" class="sick-datepicker mb-3">
            <span class="sick-datepicker-label">Abwesend ab:</span>
            <datepicker v-model="message.date_absent" :format="dateFormat"></datepicker>
          </div>
          <div class="position-relative">
            <textarea-emoji-picker v-if="!messageType.sick_note" v-model="message.message"/>
            <textarea-emoji-picker v-else v-model="message.message"/>
            <p class="text-right light-grey">{{ message.message | charsLeft(3000) }}</p>
          </div>
          <!-- <div v-else class="text-center">Im Sinne des Datenschutzes wird der Grund des Fernbleibens hier nicht erfasst.</div> -->
        </div>
      </div>

      <div v-if="messageType.poll" class="row message-new-poll mt-2">
        <div class="separator-dotted my-4 mx-auto w-100"></div>

        <div class="col-12">
          <div class="multiple-choice-checkbox">
            <label for="checkbox">
              <input id="checkbox" v-model="message.multiple_choice" type="checkbox">
              <span class="label-text">Mehrfachauswahl</span>
            </label>
          </div>
          <div class="poll-answers">

            <div v-for="(option, index) in message.options" class="poll-single-answer">
              <textarea-emoji-picker-poll @keyup.enter="addPollOption" v-model="option.title"/>
              <p class="text-right light-grey">{{ option.title | charsLeft(100) }}</p>
              <button @click="removePollOption(index)" class="remove-question">
                <img class="email-logo" :src="'./static/img/' + user.role + '/close.png'">
              </button>
            </div>
          </div>
          <div class="poll-add-question">
            <button class="btn-add-question" @click="addPollOption">Eintrag hinzufügen</button>
          </div>
        </div>
      </div>

      <div v-if="file !== null" class="row mt-4">
        <div class="col-12">

          <div @click="showFile" class="message-attachment px-3 py-2 d-flex" style="cursor: pointer">
            <img v-if="file.type.includes('pdf')" :src="'./static/img/' + user.role +'/pdf_icon.png'" alt="">
            <img v-else-if="file.type.includes('image')" :src="'./static/img/' + user.role +'/image_hdpi.png'" alt="">
            <img v-else :src="'./static/img/' + user.role +'/file_hdpi.png'" alt="">
            <div class="message-attachment-details ml-3 d-flex flex-column justify-content-center">
              <h2 class="mb-0">{{ filename }}</h2>
              <h4 class="mb-0">{{ filesize }}KB</h4>
            </div>
            <img @click.stop="removeFile" class="attach-icon btn-cursor" :src="'./static/img/' + user.role +'/close.png'">
          </div>

        </div>
      </div>

      <div class="row message-new-send">
        <div class="col-12 text-right">
          <alert :success="alert.success" :error="alert.error"/>

          <button v-if="messageType.poll || $current_user.parent" @click="sendMessage()" variant="primary" class="btn-gradient mt-4" :disabled="!hasRequriedFields || file_type_error === true">
            <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
            <span v-show="!processing">Senden</span>
          </button>

          <button v-else v-b-modal.modal-allow-answer variant="primary" class="btn-gradient mt-4" :disabled="!hasRequriedFields || file_type_error === true">
            <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
            <span v-show="!processing">Senden</span>
          </button>
          <span v-if="file_type_error === true">
            <p style="color: red">
              Anhang hat ein falsches Format. Nachrichtenübermittlung nicht mehr möglich. Schließen Sie die Nachricht und versuchen Sie es erneut.
            </p>
          </span>
          <b-modal ref="allowAnswerModal" size="sm" id="modal-allow-answer" centered class="app-modals" title="Senden und…" hide-footer>
            <button @click="sendMessageWithRespondAllow(true)" class="btn btn-neue w-100 my-1">Antwort erlauben</button>
            <button @click="sendMessageWithRespondAllow(false)" class="btn btn-neue w-100 my-1">Antwort nicht erlauben</button>
          </b-modal>

        </div>
      </div>
    </div>

    <add-receivers v-show="add_receivers" :contacts="contacts" :selectedReceivers="message.selected_receivers" :goBack="goBack"></add-receivers>

  </div>

</template>

<script>
// Components
import Alert from '@/components/Helpers/Alert';
import AddReceivers from '@/components/Messages/New/Receivers';
import Datepicker from 'vuejs-datepicker';
import TextareaEmojiPicker from '@/components/Messages/TextareaEmojiPicker'
import TextareaEmojiPickerPoll from '@/components/Messages/TextareaEmojiPickerPoll'

// API
import messageApi from '@/api/v1/messages';
import contactsApi from '@/api/v1/contacts';
import pinboardApi from '@/api/v1/pinboard';
// mixins
import alert from '@/mixins/alert';
import moment from 'moment';

export default {
  components: { Alert, AddReceivers, Datepicker, TextareaEmojiPicker, TextareaEmojiPickerPoll },
  mixins: [alert],
  data() {
    return {
      message: {
        title: '',
        selected_receivers: [],
        message: '',
        date_absent: '',
        options: [],
      },
      contacts: [],
      processing: false,
      file: null,
      filename: '',
      filesize: '',
      file_type_error: '',
      add_receivers: false,
      user: this.$current_user,
      pinboard: {
        title: '',
      },
    };
  },
  methods: {
    addPollOption() {
      this.message.options.push({ title: '' });
      this.focusLastPollItem();
    },
    focusLastPollItem() {
      this.$nextTick(() => {
        const elems = document.querySelectorAll('.poll-answer-input');
        if (elems.length > 0) {
          elems[elems.length - 1].focus();
        }
      });
    },
    removePollOption(index) {
      this.message.options.splice(index, 1);
    },
    showFile() {
      window.open(window.URL.createObjectURL(this.file));
    },
    attachmentUpload(event) {
      this.alert.error = '';
      const uploadedFile = event.target.files[0];
      if (uploadedFile && uploadedFile.name.match(/.*\.png|jpg|pdf|doc|docx|xls|xlsx/i)) {
        if (uploadedFile.size / 1024 > 20480) {
          this.alert.error = 'Die angefügte Datei ist zu groß. Der Anhang darf max. 20 MB haben.';
          return;
        }
        this.file = uploadedFile;
        this.filename = uploadedFile.name;
        this.filesize = Math.round(uploadedFile.size / 1024);
      } else {
        this.alert.error = 'Anhang hat ein falsches Format';
        this.file_type_error = true;
      }
    },
    sendMessage() {
      this.message.date_absent = moment(this.message.date_absent).format('YYYY-MM-DDTHH:mm:ssZZ');

      if (this.hasRequriedFields) {
        this.processing = true;

        if(this.messageType.poll){
          this.formatPollOption();
        }
        this.message.confirmation = this.messageType.confirmation;
        this.message.pool = this.messageType.poll;
        this.message.sick = this.messageType.sick_note;
        this.message.title = this.convertEmoji(this.message.title);
        this.message.message = this.convertEmoji(this.message.message);
        this.message.options = this.message.options.filter(option => option.title !== '');

        messageApi.new(this.message, this.file).then((response) => {
          if (response.data.statuscode !== 200) throw response;

          this.processing = false;
          this.alert.success = 'Message sent!';
          this.$router.push({
            name: 'show_message',
            params: { id: response.data.detailresponse.itemid },
          });
        }).catch((response) => {
          this.processing = false;
          this.alert.error = response.data.errormessage;
        });
      }
    },
    formatPollOption: function () {
      var options = this.message.options;
      for (var i = 0; i < options.length; i++) {
        var name = this.convertEmoji(options[i].title);
        this.message.options[i].title = name;
      }

    },
    convertEmoji(string) {
        var formatedString = '';

        for (var i = 0; i < string.length; i++) {

          if(this.emojiCheck(string[i])){
            formatedString += this.toUTF16((string[i]).codePointAt(0));
          }
          else if(this.emojiCheck(string[i] + string[i + 1]) && i < string.length) {
            formatedString += this.toUTF16((string[i] + string[i + 1]).codePointAt(0));
            i++;
          }
          else{
            formatedString += string[i];
          }
        }
        return formatedString;
    },
    toUTF16(codePoint) {
      var TEN_BITS = parseInt('1111111111', 2);
      function u(codeUnit) {
        return '\\u'+codeUnit.toString(16).toUpperCase();
      }

      if (codePoint <= 0xFFFF) {
        return u(codePoint);
      }
      codePoint -= 0x10000;

      // Shift right to get to most significant 10 bits
      var leadSurrogate = 0xD800 + (codePoint >> 10);

      // Mask to get least significant 10 bits
      var tailSurrogate = 0xDC00 + (codePoint & TEN_BITS);

      return u(leadSurrogate) + u(tailSurrogate);
    },
    emojiCheck(string) {
     const test = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/.test(string);
      return test;
    },
    sendMessageWithRespondAllow(allow) {
      this.message.answer_allowed = allow;
      this.$refs.allowAnswerModal.hide();
      this.sendMessage();
    },
    removeFile() {
      this.file = null;
      this.filename = '';
    },
    goBack() {
      this.add_receivers = !this.add_receivers;
    },
    setSickNoteHeaders() {
      this.message.title = `Krankmeldung ${this.pinboard.title}`;
      this.message.date_absent = moment().format('YYYY-MM-DD');
    },
    dateFormat(date) {
      return moment(date).format('DD.MM.YYYY');
    },
  },
  computed: {
    messageType() {
      return {
        normal: this.$route.query.type === 'normal',
        confirmation: this.$route.query.type === 'confirmation',
        poll: this.$route.query.type === 'poll',
        sick_note: this.$route.query.type === 'sick_note',
      };
    },
    hasRequriedFields() {
      const message = this.message;
      let result = message.title && message.message && message.selected_receivers.length;
      if (this.messageType.sick_note) {
        result = message.selected_receivers.length;
      } else if (this.messageType.poll) {
        result = result && message.options[0] && message.options[0].title;
      }
      return result;
    },
  },
  created() {
    pinboardApi.show((data) => {
      this.pinboard = data.detailresponse;
      if (this.messageType.sick_note) {
        this.setSickNoteHeaders();
      }
    }, this.user.child);

    contactsApi.index((response) => {
      this.contacts = response.listresponse || [];
      if (this.user.parent) {
        this.message.selected_receivers = this.message.selected_receivers.concat(this.contacts);
      }
    });
  },
  watch: {
    '$route.query.type': function setMessageTitle() {
      if (this.$route.query.type === 'normal') {
        this.message.title = '';
      } else if (this.$route.query.type === 'sick_note') {
        this.setSickNoteHeaders();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/New/Index.vue